import { render, staticRenderFns } from "./CharacterRace.vue?vue&type=template&id=31398f39&"
import script from "./CharacterRace.vue?vue&type=script&lang=js&"
export * from "./CharacterRace.vue?vue&type=script&lang=js&"
import style0 from "./CharacterRace.vue?vue&type=style&index=0&id=31398f39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports